import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldCardType'])
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldCardType'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldCardType'])
    },
}